/* eslint-disable max-len */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { dataService } from "../../../services/data.services";


const initialState = {
    loading: true,
    error: '',
    success: '',
}
export const InventoryListData = createAsyncThunk('inventory-list', async (searchParams) => {
    let res = await dataService.GetAPI(searchParams);
    return res
})
const InventoryListSlice = createSlice({

    name: 'institution-user-list',
    initialState,
    reducers: {
        setLoading: (state, action) => {
            state.loading = true
        },
        handleDataRoles: (state, action) => {
            state.roleList = action.payload
        }

    },
    extraReducers: {
        [InventoryListData.pending]: (state) => {
            state.loading = true
            state.error = null
        },
        [InventoryListData.fulfilled]: (state, action) => {
            state.loading = false;
            if(!action?.payload?.error && action?.payload?.data.status===200){
                state.List=action?.payload?.data.data;
                
            }else{
                state.error=action?.payload?.data?.message
            }
        },
        [InventoryListData.rejected]: (state, { payload }) => {
            state.loading = false
            state.error = payload?.message?.message
        },
    },
})
export const { setLoading,handleDataRoles } = InventoryListSlice.actions;
export default InventoryListSlice.reducer